import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  UpdateIntegrationParams,
  UpdateIntegrationResponse
} from "./types";

export const updateIntegrationRequest = ({
  integration,
  data
}: UpdateIntegrationParams) =>
  apiProxyRequest<UpdateIntegrationResponse>(
    integration._links["#edit"]!.href,
    "PATCH",
    data
  );
